export * from './IngredientCardLabelContainer';
